







import { Component, Prop, Vue } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";

@Component
export default class DashboardLayoutSectionTitle extends Vue {
  @Prop({ required: true })
  title!: string | TranslateResult;

  @Prop({ required: true })
  icon!: string;

  @Prop({ default: "l" })
  iconType!: string;
}
